export default __webpack_public_path__ + "e1273b772943b381630b292cb8119706.svg";